export default function AttachReportPackageReportController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  reportsDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Report Added';
  vm.isExpanded = false;
  vm.loading = false;
  vm.permissions = null;

  // Attach Event Handlers
  vm.handleAttachReport = _handleAttachReport;
  vm.handleDownloadReport = _handleDownloadReport;

  vm.handleAttachArchivedReport = _handleAttachArchivedReport;
  vm.handleDownloadArchivedReport = _handleDownloadArchivedReport;

  _activate();

  // //////// METHODS //////////

  function _activate() {
  }

  function _handleAttachReport() {
    const dfdSave = $q.defer();
    loaderService.showViewLoader = true;

    if (vm.report.attached) {
      reportsDataService.attachReportPackageReport(vm.reportPackageId, vm.report.reportInstanceId)
        .then((response) => {
          if (!response.data.reportPackageReportInstanceId) {
            alerts.error('An error occurred while attaching the Report.');
            loaderService.showViewLoader = false;
            dfdSave.reject();
          } else {
            alerts.success(`Report ${vm.report.reportName} has been attached successfully.`);
            vm.report.reportPackageReportInstanceId = response.data.reportPackageReportInstanceId;
            $rootScope.$broadcast('refreshReportPackageReports', { reportPackageId: vm.reportPackageId });
            loaderService.showViewLoader = false;
            dfdSave.resolve();
          }
        });
    } else {
      reportsDataService.detachReportPackageReport(vm.report.reportPackageReportInstanceId)
        .then(() => {
          alerts.success(`Report ${vm.report.reportName} has been detached successfully.`);
          vm.report.reportPackageReportId = null;
          $rootScope.$broadcast('refreshReportPackageReports', { reportPackageId: vm.reportPackageId });
          dfdSave.resolve();
        })
        .catch(() => {
          alerts.error('An error occurred while detaching the Report.');
          dfdSave.reject();
        })
        .finally(() => {
          loaderService.showViewLoader = false;
        });
    }
  }

  function _handleDownloadReport() {
    /*
    var $ifrmDownloadFile = angular.element('#ifrmDownloadFile');
    var $frmDownloadFile = angular.element(
    '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo($ifrmDownloadFile);
    $frmDownloadFile.attr('action', paths.handlerDirectory + 'AM/LargeFileHandler.ashx');
    $frmDownloadFile.append('<input type="hidden" name="auditPackageId" value="' + vm.auditPackageId + '" />');
    $frmDownloadFile.submit();
    */
  }

  function _handleAttachArchivedReport() {
    const dfdSave = $q.defer();
    loaderService.showViewLoader = true;

    if (vm.reportArchive.attached) {
      reportsDataService.attachReportPackageArchivedReport(vm.reportPackageId, vm.reportArchive.reportInstanceArchiveId)
        .then((response) => {
          if (!response.data.reportPackageReportInstanceId) {
            alerts.error('An error occurred while attaching the Archived Report.');
            loaderService.showViewLoader = false;
            dfdSave.reject();
          } else {
            alerts.success(`Archived Report ${vm.reportArchive.reportName} has been attached successfully.`);
            vm.reportArchive.reportPackageReportInstanceId = response.data.reportPackageReportInstanceId;
            $rootScope.$broadcast('refreshReportPackageReports', { reportPackageId: vm.reportPackageId });
            loaderService.showViewLoader = false;
            dfdSave.resolve();
          }
        });
    } else {
      reportsDataService.detachReportPackageArchivedReport(vm.reportArchive.reportPackageReportInstanceId)
        .then(() => {
          alerts.success(`Report ${vm.reportArchive.reportName} has been detached successfully.`);
          vm.reportArchive.reportPackageReportId = null;
          $rootScope.$broadcast('refreshReportPackageReports', { reportPackageId: vm.reportPackageId });
          dfdSave.resolve();
        })
        .catch(() => {
          alerts.error('An error occurred while detaching the Archived Report.');
          dfdSave.reject();
        })
        .finally(() => {
          loaderService.showViewLoader = false;
        });
    }
  }

  function _handleDownloadArchivedReport() {
    /*
    var $ifrmDownloadFile = angular.element('#ifrmDownloadFile');
    var $frmDownloadFile = angular.element(
    '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo($ifrmDownloadFile);
    $frmDownloadFile.attr('action', paths.handlerDirectory + 'AM/LargeFileHandler.ashx');
    $frmDownloadFile.append('<input type="hidden" name="auditPackageId" value="' + vm.auditPackageId + '" />');
    $frmDownloadFile.submit();
    */
  }
}

AttachReportPackageReportController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'reportsDataService',
];
